<template>
  <div
    class="modal fade"
    id="dragAndDropOrResizeEventModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="dragAndDropOrResizeEventModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog sx-modal-responsive modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="dragAndDropOrResizeEventModalLabel">
            <i class="fa fa-info-circle"></i>
            {{
              $t(
                "Components.ValidationMessages.Title",
                {},
                { locale: this.$store.state.activeLang }
              )
            }}
          </h5>
          <button
            type="button"
            @click="close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <ValidationMessageList
            :isModal="true"
            :errors="errors"
            :warnings="warnings"
            :informations="informations"
          />
          <BusinessRuleResponseGrid
            :parentClasses="errors || warnings || informations ? 'mt-2' : ''"
            :errors="businessRuleErrors"
          />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-bs-dismiss="modal"
          >
            <i class="fa fa-times"></i>
            {{
              $t(
                "BaseModelFields.Close",
                {},
                { locale: this.$store.state.activeLang }
              )
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BusinessRuleResponseGrid from "@/components/custom/set-pages/BusinessRuleResponseGrid.vue";
import ValidationMessageList from "@/components/custom/validation-message/List.vue";
export default {
  name: "ValidationMessageModal",
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    businessRuleErrors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
    informations: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ValidationMessageList,
    BusinessRuleResponseGrid,
  },
};
</script>
